module.exports = __webpack_public_path__ + "img/48.66d767d6.webp";